import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'json-to-csv',
  name: 'JSON to CSV',
  category: 'utilities',
  description: 'Convert JSON data to CSV format',
  icon: 'FileText',
  color: 'blue',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
